export const chakraColors = {
  baseMapFill: "#fafaf8",
  baseMapStroke: "#e6eaeb",
  baseMapBg: "#d5dadc",
  gold: {
    50: "#faf3e4",
    100: "#e4dccb",
    200: "#d0c5ad",
    300: "#bbae8f",
    400: "#a89671",
    500: "#8e7d57",
    600: "#6f6143",
    700: "#50452e",
    800: "#302a19",
    900: "#150d00",
  },
  deep: {
    50: "#e9e8ff",
    100: "#bfbcf7",
    200: "#948fef",
    300: "#6a63e8",
    400: "#4137e0",
    500: "#281ec7",
    600: "#1e169b",
    700: "#151070",
    800: "#0c0a45",
    900: "#04021b",
  },
  spark: {
    50: "#e1fff9",
    100: "#b9f8ed",
    200: "#90f3e1",
    300: "#66eed5",
    400: "#43eac9",
    500: "#31d0b0",
    600: "#24a288",
    700: "#177461",
    800: "#07463a",
    900: "#001813",
  },
  mist: {
    50: "#e7fafd",
    100: "#c7e3eb",
    200: "#a4ceda",
    300: "#81b8cb",
    400: "#5fa0bd",
    500: "#4683a3",
    600: "#366480",
    700: "#26465c",
    800: "#142938",
    900: "#021017",
  },
};
